import React from 'react';
import { Box, Divider, Fade, Typography } from '@mui/material';
import ApiKeySkeleton from './ApiKeySkeleton';
import ApiKeyItem from './ApiKeyItem';

import { styles } from './ApiKeyUtil';

const ApiKeyList = ({
  apiKeys,
  initialLoading,
  keyPendingDeletion,
  onDeleteStart,
  onDeleteCancel,
  onDeleteConfirm,
  onUpdateWorkflows,
  allWorkflows,
  isFetchingAllWorkflows,
  isLoading,
}) => {
  if (initialLoading) {
    return (
      <Box sx={styles.list.container}>
        <ApiKeySkeleton />
        <Divider />
        <ApiKeySkeleton />
      </Box>
    );
  }

  if (apiKeys.length === 0) {
    return (
      <Fade in={true} timeout={500}>
        <Box sx={styles.list.emptyState}>
          <Typography variant="body2" color="text.secondary">
            You don't have any API keys yet
          </Typography>
        </Box>
      </Fade>
    );
  }

  return (
    <Fade in={!initialLoading} timeout={500}>
      <Box sx={styles.list.container}>
        {apiKeys.map((key, index) => (
          <Box key={key.id}>
            {index > 0 && <Divider />}
            <ApiKeyItem
              apiKey={key}
              isPendingDeletion={keyPendingDeletion === key.id}
              onDeleteStart={onDeleteStart}
              onDeleteCancel={onDeleteCancel}
              onDeleteConfirm={onDeleteConfirm}
              onUpdateWorkflows={onUpdateWorkflows}
              allWorkflows={allWorkflows}
              isFetchingAllWorkflows={isFetchingAllWorkflows}
              isLoading={isLoading && keyPendingDeletion === key.id}
            />
          </Box>
        ))}
      </Box>
    </Fade>
  );
};

export default ApiKeyList;
